// Marker: payment_slip_v1
import React, { useState, useEffect } from 'react';

function fmtSlipDate(d) {
  if (!d) return '';
  try {
    return new Date(d).toLocaleString('th-TH', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch (e) { return ''; }
}

function badge(st) {
  if (st === 'approved') return { t: '✅ อนุมัติแล้ว', bg: '#dcfce7', c: '#166534' };
  if (st === 'rejected') return { t: '❌ ไม่ผ่าน', bg: '#fee2e2', c: '#991b1b' };
  return { t: '🕐 รอตรวจสอบ', bg: '#fef3c7', c: '#92400e' };
}

export default function SlipUpload(props) {
  const token = props.token;
  const currency = props.currency || 'THB';
  const [preview, setPreview] = useState('');
  const [amount, setAmount] = useState('');
  const [uploading, setUploading] = useState(false);
  const [slips, setSlips] = useState([]);
  const [msg, setMsg] = useState('');

  function loadSlips() {
    fetch('/api/public/invoices/' + encodeURIComponent(token) + '/slips')
      .then(function (r) { return r.ok ? r.json() : { slips: [] }; })
      .then(function (d) { setSlips((d && d.slips) || []); })
      .catch(function () {});
  }

  useEffect(function () { if (token) loadSlips(); }, [token]);

  function onFile(e) {
    var f = e.target.files && e.target.files[0];
    if (!f) return;
    if (f.size > 5 * 1024 * 1024) { setMsg('ไฟล์ใหญ่เกิน 5MB'); return; }
    setMsg('');
    var reader = new FileReader();
    reader.onload = function (ev) { setPreview(ev.target.result); };
    reader.readAsDataURL(f);
  }

  function submit() {
    if (!preview) { setMsg('กรุณาเลือกสลิป'); return; }
    setUploading(true); setMsg('');
    fetch('/api/public/invoices/' + encodeURIComponent(token) + '/slip', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image_base64: preview, amount: amount || null })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        setUploading(false);
        if (res.ok) {
          /* bill_slip_autoverify_v1: ถ้าตรวจอัตโนมัติผ่านแล้ว */
          if (res.body && res.body.auto && res.body.auto.paid) {
            setMsg('✅ ยืนยันการชำระเงินอัตโนมัติแล้ว! ขอบคุณครับ 🎉');
          } else {
            setMsg('✅ ส่งสลิปสำเร็จแล้ว รอตรวจสอบ');
          }
          setPreview(''); setAmount('');
          loadSlips();
        } else {
          setMsg((res.body && res.body.error) ? ('เกิดข้อผิดพลาด: ' + res.body.error) : 'ส่งสลิปไม่สำเร็จ');
        }
      })
      .catch(function () { setUploading(false); setMsg('ส่งสลิปไม่สำเร็จ'); });
  }

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 8 }}>📤 อัพโหลดสลิปการโอน</div>
      {slips.length > 0 ? (
        <div style={{ marginBottom: 10 }}>
          {slips.map(function (sp) {
            var b = badge(sp.status);
            return (
              <div key={sp.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 10px', background: b.bg, borderRadius: 8, marginBottom: 6 }}>
                <span style={{ fontSize: 12, fontWeight: 600, color: b.c }}>{b.t}</span>
                <span style={{ fontSize: 11, color: b.c }}>{fmtSlipDate(sp.uploaded_at)}</span>
              </div>
            );
          })}
        </div>
      ) : null}
      <div style={{ background: '#f8fafc', borderRadius: 10, padding: 14 }}>
        <input type="file" accept="image/*" onChange={onFile} style={{ fontSize: 13, width: '100%', marginBottom: 10 }} />
        {preview ? <img src={preview} alt="slip" style={{ maxWidth: '100%', maxHeight: 200, borderRadius: 8, marginBottom: 10, display: 'block' }} /> : null}
        <input type="text" inputMode="decimal" placeholder={'จำนวนเงินที่โอน (' + currency + ')'} value={amount} onChange={function (e) { setAmount(e.target.value); }} style={{ fontSize: 14, width: '100%', padding: '8px 10px', border: '1px solid #e2e8f0', borderRadius: 8, boxSizing: 'border-box', marginBottom: 10 }} />
        <button onClick={submit} disabled={uploading || !preview} style={{ width: '100%', padding: '12px', background: (uploading || !preview) ? '#cbd5e1' : '#2563eb', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: (uploading || !preview) ? 'not-allowed' : 'pointer' }}>{uploading ? 'กำลังอัพโหลด...' : '📤 ส่งสลิป'}</button>
        {msg ? <div style={{ marginTop: 10, fontSize: 12, color: '#475569', textAlign: 'center' }}>{msg}</div> : null}
      </div>
    </div>
  );
}
